<template>
  <v-sheet>
    <v-navigation-drawer
      app
      enable-resize-watcher
      :stateless="!$vuetify.breakpoint.smAndDown"
      disable-resize-watcher
      v-model="sideDrawer"
      class="elevation-4"
      :width="350"
      style="z-index: 3000"
    >
      <v-toolbar dense elevation="0">
        <v-tooltip bottom open-delay="500">
          <template v-slot:activator="{ on, attrs }">
            <v-btn small icon style="margin-left: -8px; margin-right: 5px"
                   @click="sideDrawer=!sideDrawer" v-bind="attrs" v-on="on">
              <v-icon>mdi-chevron-double-left</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("report.panel_hide") }}</span>
        </v-tooltip>

        <v-menu z-index="4000" open-on-hover>
          <template v-slot:activator="{ on: menu, attrs }">
            <v-btn
              fab
              x-small
              color="orange"
              elevation="2"
              v-bind="attrs"
              v-on="{ ...menu }"
            >
              <span
                style="font-weight: bold; font-size: 20px; color: white; -webkit-text-stroke: 1px #ffc979; ">S</span>
            </v-btn>
          </template>
          <v-card>
            <MainMenu />
          </v-card>
        </v-menu>

        <v-toolbar-title style="padding-left: 10px">{{ title }}</v-toolbar-title>
        <v-spacer />

        <v-tooltip bottom open-delay="500">
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon @click="close" v-bind="attrs" v-on="on">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("report.close") }}</span>
        </v-tooltip>

      </v-toolbar>

      <v-divider class="mx-2" />

      <router-view
        v-on:report="setReport"
        v-on:pdf="setPdf"
      />

      <v-container>
        <v-btn plain color="primary" :disabled="!loaded" @click="downloadReport('pdf')">
          {{ $t("report.save_as_pdf") }}
        </v-btn>
        <v-btn plain color="primary" :disabled="!loaded" @click="downloadReport('xlsx')">
          {{ $t("report.save_as_xlsx") }}
        </v-btn>
      </v-container>

    </v-navigation-drawer>

    <div :key="change" style="max-height: 100vh" class="overflow-y-auto">
      <pdf ref="pdfRef"
           v-for="i in pageCount"
           :key="i"
           :id="i"
           :src="pdf"
           :page="i"
           :resize="true"
           @error="error"
      >
      </pdf>
    </div>

    <template v-if="!sideDrawer">
      <v-menu z-index="4000" open-on-hover>
        <template v-slot:activator="{ on: menu, attrs }">
          <v-btn
            fab
            top
            left
            small
            fixed
            color="orange"
            elevation="2"
            v-bind="attrs"
            v-on="{ ...menu }"
          >
            <span style="font-weight: bold; font-size: 30px; color: white; -webkit-text-stroke: 1px #ffc979">S</span>
          </v-btn>
        </template>
        <v-card>
          <MainMenu />
        </v-card>
      </v-menu>

      <v-tooltip bottom open-delay="500">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            top
            left
            icon
            small
            fixed
            style="margin-top: 50px; background-color: white"
            elevation="2"
            @click="sideDrawer=!sideDrawer" v-bind="attrs" v-on="on">
            <v-icon>mdi-chevron-double-right</v-icon>
          </v-btn>
        </template>
        <span>{{ $t("report.panel_show") }}</span>
      </v-tooltip>

    </template>

  </v-sheet>
</template>

<script>
import pdf from "pdfvuer";
import MainMenu from "@/components/MainMenu";

export default {
  name: "ReportView",

  components: {
    pdf,
    MainMenu
  },

  data() {
    return {
      report: null,
      title: "",
      sideDrawer: true,
      pdf: null,
      page: 1,
      pageCount: null,
      loaded: false,
      change: true
    };
  },

  computed: {},

  methods: {
    setPdf(source) {
      this.change = !this.change;
      this.loaded = false;
      //this.pdf = URL.createObjectURL(source);
      this.pdf = pdf.createLoadingTask(URL.createObjectURL(source));

      this.pdf.then(p => {
        this.loaded = true;
        this.pageCount = p.numPages;
      });
    },

    print() {
      this.$refs.pdfRef.print();
    },

    error() {
    },

    setReport(report) {
      this.report = report;
      this.title = this.$t("report." + report.name + ".title");
    },

    downloadReport(output) {
      this.report.download(output);
    },

    close() {
      this.$router.close({ name: "map" });
    }
  },

  watch: {
    page: function(p) {
      if (window.pageYOffset <= this.findPos(document.getElementById(p)) || (document.getElementById(p + 1) && window.pageYOffset >= this.findPos(document.getElementById(p + 1)))) {
        // window.scrollTo(0,this.findPos(document.getElementById(p)));
        document.getElementById(p).scrollIntoView();
      }
    },

    $route() {
      this.pdf = null;
    }
  },

  // eslint-disable-next-line no-unused-vars
  beforeRouteUpdate (to, from, next) {
    this.pdf = null;
    next()
  }
};
</script>

<style src="pdfvuer/dist/pdfvuer.css"></style>
<style scoped>
</style>
